<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <BasePreloader v-if="pending"/>
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div v-if="!pending" class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="../assets/img/resume-popups/response.svg"
                   :alt="$tVacancy('Apply for job')">
            </picture>
          </div>

          <RespondOnVacancyStatuses v-if="status || message"
                                :status="status"
                                :message="message"
                                @close="close"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RespondOnVacancyStatuses from "@/components/RespondOnVacancyStatuses"

  export default {
    name: 'ModalRespondOnAllMessage',
    components: {
      RespondOnVacancyStatuses
    },
    props: ['status', 'message'],
    data() {
      return {
        pending: false
      }
    },
    methods: {
      close() {
        this.$vModal.close('respond-on-all-message')
      }
    }
  }
</script>

<style lang="less">

</style>
